// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__3MmM1","marketplaceStroke":"IconEmailAttention_marketplaceStroke__x20ti","attentionStroke":"IconEmailAttention_attentionStroke__908ip"};